
import { Vue, Component, Prop } from 'vue-property-decorator'
import CustomButton from '../buttons/CustomButton.vue';
import Processing from '@/components/common/Processing.vue';
import Spinner from '@/components/common/Spinner.vue';
@Component({
    components: {
        CustomButton,
        Processing,
        Spinner
    },
})

export default class SchedulerOverlay extends Vue {
    @Prop({ type: Boolean, default: false }) readonly hasData!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isLoading!: boolean;

    @Prop({ type: String, default: 'No information available' }) readonly customPlaceholderMessage!: string;
    @Prop({ type: String, default: '' }) readonly type!: string;

    //get button from type
    get buttonText() {
        switch (this.type) {
            case 'Manager':
                return 'Invite Manager';
            case 'Project':
                return 'Add Project';
            case 'Resource':
                return 'Invite Resource';
            default:
                return 'Add Project';
        }
    }

    get showNoInformation(): boolean {
        return !this.hasData && !this.isLoading;
    }

}
